import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './AuthContext'; // Import AuthProvider
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './css/ErrorBoundary.css';
import ErrorBoundary from './components/ErrorBoundary';
import Rules from './components/Rules';
import Bingo from './components/Bingo';
import Login from './components/Login';
import Register from './components/Register';
import ForgotPassword from './components/ForgotPassword';
import Admin from './components/Admin'; // Import the Admin component
import Profile from './components/Profile';
import FriendsProfile from './components/FriendsProfile';
import BookPage from './components/Book';
import BookRecommendation from './components/BookRecommendation';
import ProtectedRoute from './utils/ProtectedRoute';
import GuestProtectedRoute from './utils/GuestProtectedRoute';

function App() {
    return (
        <ErrorBoundary>
            <AuthProvider>
                <BrowserRouter>
                    <ToastContainer />
                    <Routes>
                        {/* Public routes */}
                        <Route path="/register" element={<Register />} />
                        <Route path="/login" element={<Login />} />
                        <Route path="/forgot-password" element={<ForgotPassword />} />
                        <Route path="/" element={<Navigate to="/login" />} />

                        {/* Routes accessible to both guests and authenticated users */}
                        <Route path="/rules" element={
                            <GuestProtectedRoute>
                                <Rules />
                            </GuestProtectedRoute>
                        } />
                        <Route path="/bingo" element={
                            <GuestProtectedRoute>
                                <Bingo />
                            </GuestProtectedRoute>
                        } />

                        {/* Protected routes - require full authentication */}
                        <Route path="/profile" element={
                            <GuestProtectedRoute>
                                <ProtectedRoute>
                                    <Profile />
                                </ProtectedRoute>
                            </GuestProtectedRoute>
                        } />
                        <Route path="/friend/:userId" element={
                            <GuestProtectedRoute>
                                <ProtectedRoute>
                                    <FriendsProfile />
                                </ProtectedRoute>
                            </GuestProtectedRoute>
                        } />
                        <Route path="/book/:isbn" element={
                            <GuestProtectedRoute>
                                <ProtectedRoute>
                                    <BookPage />
                                </ProtectedRoute>
                            </GuestProtectedRoute>
                        } />
                        <Route path="/recommendations" element={
                            <GuestProtectedRoute>
                                <ProtectedRoute>
                                    <BookRecommendation />
                                </ProtectedRoute>
                            </GuestProtectedRoute>
                        } />

                        {/* Admin routes */}
                        <Route path="/admin" element={
                            <GuestProtectedRoute>
                                <ProtectedRoute requireAdmin={true}>
                                    <Admin />
                                </ProtectedRoute>
                            </GuestProtectedRoute>
                        } />

                        {/* Catch all - redirect to home */}
                        <Route path="*" element={<Navigate to="/" />} />
                    </Routes>
                </BrowserRouter>
            </AuthProvider>
        </ErrorBoundary>
    );
}

export default App;
